<template>
  <div class="pb-2">
    <div class="pt-4">
      <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
        <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8"
          >
          {{ $t('message.searchComponent.employee') }}
        </label
        >
        <div>
          <div>
            <MultiSelect
              @search-change="debounceFindEmployee"
              :value="selectedEmployee"
              @input="setSelectedEmployee"
              :options="employeeItems"
              :searchable="true"
              label="nombre"
              :multiple="true"
              :internal-search="false"
              :clear-on-select="true"
              :close-on-select="false"
              :loading="isLoading"
              :preserve-search="false"
              :tag-placeholder="$t('message.searchComponent.form_select')"
              :show-labels="false"
              :show-no-options="false"
              placeholder=""
              track-by="id"
              data-vs-select="selected-employe"
            >
              <template slot="noResult"
                ><span class="multiselect__single">{{
                  $t('message.searchComponent.not_founded')
                }}</span></template
              >
              <template slot="maxElements"
                ><span class="multiselect__single">{{
                  $t('message.searchComponent.max_elements')
                }}</span></template
              >
              <template #tag="{ remove, option }">
                <CustomChip @click="remove(option)">{{ option.nombre }}</CustomChip>
              </template>

              <template #caret>
                <span class="hidden"></span>
              </template>
            </MultiSelect>
          </div>
        </div>
      </div>
      <p
        class="py-2 text-zt-dark-300 text-zt-xs"
        v-if="country === 'BO' || country === 'EC' || country === 'PY'"
      >
        {{ $t('message.searchComponent.searchBy') }}
      </p>
      <p
        class="py-2 text-zt-dark-300 text-zt-xs"
        v-else-if="country === 'CW' || country === 'TT' || country === 'BB'"
      >
        {{ $t('message.searchComponent.searchBy2') }}
      </p>
      <p class="py-2 text-zt-dark-300 text-zt-xs" v-else>
        {{ $t('message.searchComponent.searchBy3') }}
      </p>
    </div>
    <div class="border border-zt-dark-300 rounded px-2 pt-1 relative mt-2">
      <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">
        {{ $t('message.searchComponent.fileNumber') }}</label
      >
      <div>
        <zt-input
          ref="fileNumber"
          v-model="fileNumber"
          v-validate="{ numeric: true, max: 20 }"
          @input="setFileNumber"
          color="#E0E0E0"
          name="fileNumber"
          data-vs-input="fileNumber"
        />
      </div>
    </div>
    <div class="text-zt-danger text-base" v-if="errors.has('fileNumber')">
      <span>
        {{ errors.first('fileNumber') }}
      </span>
    </div>
    <div class="pt-4">
      <div>
        <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
          <label
            class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8"
            >
            {{ $t('message.searchComponent.documentType') }}
          </label
          >
          <MultiSelect
            :value="selectedFolder"
            @input="setSelectedSubFolder"
            :options="foldersItems"
            :multiple="true"
            track-by="id"
            label="name"
            :clear-on-select="true"
            :close-on-select="false"
            :show-labels="false"
            :show-no-options="false"
            placeholder=""
            data-vs-select="select-folder"
          >
            <template slot="noResult"
              ><span class="multiselect__single">{{
                $t('message.searchComponent.not_founded')
              }}</span></template
            >
            <template #tag="{ remove, option }">
              <CustomChip @click="remove(option)">{{ option.name }}</CustomChip>
            </template>
          </MultiSelect>
        </div>
      </div>
    </div>
     <div class="pt-4" v-if="isManPower">
      <div>
        <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
          <label
            class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8"
            >
            {{ $t('message.searchComponent.company') }}
          </label
          >
          <MultiSelect
            :value="selectedCompany"
            @input="setSelectedCompany"
            :options="companiesOpts"
            :multiple="true"
            :searchable="true"
            :internal-search="true"
            :clear-on-select="true"
            :close-on-select="false"
            :show-labels="false"
            :show-no-options="false"
            placeholder=""
            data-vs-select="select-company"
          >
            <template slot="noResult"
              ><span class="multiselect__single">{{
                $t('message.searchComponent.not_founded')
              }}</span></template
            >
            <template #tag="{ remove, option }">
              <CustomChip @click="remove(option)">{{ option }}</CustomChip>
            </template>
          </MultiSelect>
        </div>
      </div>
    </div>
    <div class="pt-4" v-if="isManPower">
      <div>
        <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
          <label
            class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8"
            >
            {{ $t('message.searchComponent.branch') }}
          </label
          >
          <MultiSelect
            :value="selectedBranch"
            @input="setSelectedBranch"
            :options="branchesOpts"
            :multiple="true"
            :searchable="true"
            :internal-search="true"
            :clear-on-select="true"
            :close-on-select="false"
            :show-labels="false"
            :show-no-options="false"
            placeholder=""
            data-vs-select="select-branch"
          >
            <template slot="noResult"
              ><span class="multiselect__single">{{
                $t('message.searchComponent.not_founded')
              }}</span></template
            >
            <template #tag="{ remove, option }">
              <CustomChip @click="remove(option)">{{ option }}</CustomChip>
            </template>
          </MultiSelect>
        </div>
      </div>
    </div>
    <div class="pt-4" v-if="isManPower">
      <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
        <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8"
          >
          {{ $t('message.searchComponent.client_cuit') }}
        </label
        >
        <div>
          <div>
            <MultiSelect
              @search-change="debounceFindCuit"
              :value="selectedCuit"
              @input="setSelectedCuit"
              :options="cuitItems"
              :searchable="true"
              label="nombre"
              :multiple="true"
              :internal-search="false"
              :clear-on-select="true"
              :close-on-select="false"
              :loading="isLoading"
              :preserve-search="false"
              :tag-placeholder="$t('message.searchComponent.form_select')"
              :show-labels="false"
              :show-no-options="false"
              placeholder=""
              track-by="id"
              data-vs-select="selected-employe"
            >
              <template slot="noResult"
                ><span class="multiselect__single">{{
                  $t('message.searchComponent.not_founded')
                }}</span></template
              >
              <template slot="maxElements"
                ><span class="multiselect__single">{{
                  $t('message.searchComponent.max_elements')
                }}</span></template
              >
              <template #tag="{ remove, option }">
                <CustomChip @click="remove(option)">{{ option.nombre }}</CustomChip>
              </template>

              <template #caret>
                <span class="hidden"></span>
              </template>
            </MultiSelect>
          </div>
        </div>
      </div>
    </div>
    <div>
      <DateFilter @signed-date="setSignedFilters" ref="dateFilter" />
    </div>
    <div>
      <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
        <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8"
          >
          {{ $t('message.searchComponent.status') }}
        </label
        >
        <div>
          <MultiSelect
            :value="statusSelected"
            @input="setStatusSelected"
            :options="statusOpts"
            :searchable="true"
            :multiple="true"
            :internal-search="false"
            :clear-on-select="true"
            :close-on-select="false"
            :preserve-search="false"
            :show-labels="false"
            :show-no-options="false"
            placeholder=""
            class="multiselect-component-state"
            data-vs-select="status-selected"
          >
            <template slot="noResult"
              ><span class="multiselect__single">{{
                $t('message.searchComponent.not_founded')
              }}</span></template
            >
            <template slot="maxElements"
              ><span class="multiselect__single">{{
                $t('message.searchComponent.max_elements')
              }}</span></template
            >
            <template #tag="{ remove, option }">
              <CustomChip @click="remove(option)">{{ option }}</CustomChip>
            </template>
          </MultiSelect>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import Search from '@/apiClient/Search'
import Folders from '@/apiClient/Folders'
import Company from '@/apiClient/Company'
import MultiSelect from 'vue-multiselect'
import CustomChip from './CustomChip.vue'
import DateFilter from './DateFilter.vue'
import { addFilters } from './utils'
import {
  flatten,
  map,
  isEmpty,
  filter,
  flatMap,
  some,
  reduce,
  pick,
  has,
  debounce,
} from 'lodash'
import { mapGetters } from 'vuex'

const MANPOWER_COMPANY_ID = 135

const sendGTMCustomEvent = (event) => {
  window.dataLayer.push({
    event,
    action: 'Click',
    value: 500,
  })
}

export default {
  name: 'SearchMainSection',
  components: {
    MultiSelect,
    CustomChip,
    DateFilter,
  },
  inject: ['store', 'setFilters', 'setFoldersItems', 'setHistoryParams'],
  data() {
    return {
      employeeItems: [],
      cuitItems: [],
      subFoldersEforms: [],
      isLoading: false,
      selectedEmployee: '',
      selectedCuit: '',
      fileNumber: '',
      client_cuit: '',
      foldersItems: [],
      selectedFolder: '',
      foldersConfig: new Folders(),
      searchConfig: new Search(),
      companyConfig: new Company(),
      companiesOpts: [],
      selectedCompany: [],
      branchesOpts: [],
      selectedBranch: [],
      signedFilters: '',
      statusSelected: [],
      statusOpts: [
        'FIRMADO CONFORME',
        'NO FIRMADO',
        'FIRMADO DISCONFORME',
        'NO REQUIERE FIRMA',
        'RECHAZADO',
        'PENDIENTE APROBACION',
        'ANULADO',
      ],
      country: '',
      debounceFindEmployee: '',
      debounceFindCuit: '',
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    isManPower() {
      return this.$store.state.user.empresa.id === MANPOWER_COMPANY_ID
    },
  },
  async created() {
    this.debounceFindEmployee = debounce((key) => this.findEmployee(key), 500)
    this.debounceFindCuit = debounce((key) => this.findCuit(key), 500)
    this.country = this.getUser.pais
    try {
      const responseFolders = await this.foldersConfig.getFoldersAndEforms()

      const {
        data: { data },
      } = responseFolders

      this.subFoldersEforms = flatMap(
        filter(data, { type: 'eforms' }),
        (subFolder) => subFolder.childs
      )

      this.foldersItems = flatten(map(data, 'childs'))
      this.setFoldersItems(data)

      if (this.existHistoryProperty('subFolderId')) {
        this.selectedFolder = this.foldersItems.filter((item) => {
          return this.store.history.params.subFolderId.indexOf(item.id) > -1
        })
      }

      if (this.existHistoryProperty('eformSingle')) {
        const eformsSelected = this.subFoldersEforms.filter((item) => {
          return this.store.history.params.eformSingle.indexOf(item.id) > -1
        })

        this.selectedFolder = [...this.selectedFolder, ...eformsSelected]
      }
    } catch (error) {
      this.foldersItems = []
    }

    if (this.existHistoryProperty('signStatus')) {
      this.statusSelected = this.store.history.params.signStatus
    }

    if (this.existHistoryProperty('userId')) {
      this.selectedEmployee = this.store.history.params.userId
    }

    if (this.existHistoryProperty('client')) {
      this.selectedCuit = this.store.history.params.client
    }

    try {
      const responseCompanies = await this.companyConfig.retrieveExtraField({ 
        column: 'empresa' 
      })
      this.companiesOpts = responseCompanies.data.results.data
      console.log(this.companiesOpts);
      
      if (this.existHistoryProperty('company')) {
        this.selectedCompany = this.store.history.params.company
      }
    } catch (error) {
      this.companiesOpts = []
    }

    try {
      const responseBranches = await this.companyConfig.retrieveExtraField({ 
        column: 'sucursal' 
      })
      this.branchesOpts = responseBranches.data.results.data
      
      if (this.existHistoryProperty('branch')) {
        this.selectedBranch = this.store.history.params.branch
      }
    } catch (error) {
      this.branchesOpts = []
    }
  },
  methods: {
    setStoreFilter(key, input) {
      const { filters } = this.store
      const newFilters = addFilters({ ...filters }, [key, input])
      this.setFilters(newFilters)
    },

    async findEmployee(key) {
      this.isLoading = true
      try {
        if (key.length >= 3) {
          const response = await this.searchConfig.SearchEmployee(key)

          const {
            data: { data },
          } = response

          this.employeeItems = data
        }
        this.isLoading = false
      } catch (error) {
        this.employeeItems = []
        this.isLoading = false
      }
    },

    async findCuit(key) {
      this.isLoading = true
      try {
        if (key.length >= 3) {
          const response = await this.companyConfig.retrieveExtraField({
            column: 'cliente',
            search: key
          })

          const cuitData = response.data.results.data
          // Transformar los datos para que tengan la estructura esperada por el multiselect
          this.cuitItems = cuitData.map((cuit, index) => ({
            id: index,
            nombre: cuit
          }))
        }
        this.isLoading = false
      } catch (error) {
        this.cuitItems = []
        this.isLoading = false
      }
    },

    setSelectedEmployee(value) {
      sendGTMCustomEvent('zt-gtm-documents-search-userfilter')

      this.selectedEmployee = value
      if (this.selectedEmployee) {
        const {
          filters,
          history: { params },
        } = this.store

        const newFilters = addFilters({ ...filters }, [
          'userId',
          map(this.selectedEmployee, 'id'),
        ])

        this.setFilters(newFilters)

        this.setHistoryParams(
          addFilters({ ...params }, [
            'userId',
            map(this.selectedEmployee, (i) => pick(i, 'id', 'nombre')),
          ])
        )
      }
    },
    setSelectedCuit(value) {
      sendGTMCustomEvent('zt-gtm-documents-search-cuitfilter')

      this.selectedCuit = value
      if (this.selectedCuit) {
        const {
          filters,
          history: { params },
        } = this.store

        const newFilters = addFilters({ ...filters }, [
          'client',
          map(this.selectedCuit, 'nombre'),
        ])

        this.setFilters(newFilters)

        this.setHistoryParams(
          addFilters({ ...params }, [
            'client',
            map(this.selectedCuit, (i) => pick(i, 'id', 'nombre')),
          ])
        )
      }
    },
    setFileNumber(value) {
      sendGTMCustomEvent('zt-gtm-documents-search-documenttypefilter')
      this.fileNumber = value
      const {
        filters,
        history: { params },
      } = this.store
      const newFilters = addFilters({ ...filters }, ['fileNumber', value])
      this.setFilters(newFilters)
      this.setHistoryParams(addFilters({ ...params }, ['fileNumber', value]))
    },

    setSelectedSubFolder(value) {
      sendGTMCustomEvent('zt-gtm-documents-search-documenttypefilter')

      this.selectedFolder = value
      if (this.selectedFolder) {
        const {
          filters,
          history: { params },
        } = this.store

        const foldersDocuments = reduce(
          this.selectedFolder,
          (acc, folder) => {
            if (!some(this.subFoldersEforms, { id: folder.id })) acc.push(folder.id)

            return acc
          },
          []
        )

        const eformsDocuments = reduce(
          this.selectedFolder,
          (acc, folder) => {
            if (some(this.subFoldersEforms, { id: folder.id })) acc.push(folder.id)

            return acc
          },
          []
        )

        const newFilters = addFilters(
          { ...filters },
          ['subFolderId', foldersDocuments],
          ['eform', eformsDocuments]
        )

        this.setFilters(newFilters)

        this.setHistoryParams(
          addFilters(
            { ...params },
            ['subFolderId', foldersDocuments],
            ['eformSingle', eformsDocuments]
          )
        )
      }
    },

    setSignedFilters(value) {
      const { signed } = value
      if (signed && !isEmpty(signed)) {
        const {
          filters,
          history: { params },
        } = this.store
        const newFilters = addFilters(
          { ...filters },
          ['periodFrom', signed.start],
          ['periodTo', signed.end]
        )

        this.setFilters(newFilters)

        this.setHistoryParams(
          addFilters(
            { ...params },
            ['periodFrom', signed.start],
            ['periodTo', signed.end]
          )
        )
      }
    },

    setStatusSelected(value) {
      sendGTMCustomEvent('zt-gtm-documents-search-statefilter')
      this.statusSelected = value
      this.setStoreFilter('signStatus', [...this.statusSelected])

      const {
        history: { params },
      } = this.store

      this.setHistoryParams(
        addFilters({ ...params }, ['signStatus', [...this.statusSelected]])
      )
    },

    setSelectedCompany(value) {
      sendGTMCustomEvent('zt-gtm-documents-search-companyfilter')
      this.selectedCompany = value
      this.setStoreFilter('company', [...this.selectedCompany])

      const {
        history: { params },
      } = this.store

      this.setHistoryParams(
        addFilters({ ...params }, ['company', [...this.selectedCompany]])
      )
    },

    setSelectedBranch(value) {
      sendGTMCustomEvent('zt-gtm-documents-search-branchfilter')
      this.selectedBranch = value
      this.setStoreFilter('branch', [...this.selectedBranch])

      const {
        history: { params },
      } = this.store

      this.setHistoryParams(
        addFilters({ ...params }, ['branch', [...this.selectedBranch]])
      )
    },

    cleanFilters() {
      this.selectedEmployee = ''
      this.selectedCuit = ''
      this.selectedFolder = ''
      this.statusSelected = []
      this.selectedCompany = []
      this.selectedBranch = []
      this.$refs.fileNumber._data.textFieldValue = ''
      this.$refs.dateFilter.clearInputs()
    },

    existHistoryProperty(property) {
      const {
        history: { params },
      } = this.store
      return has(params, property)
    },
  },
}
</script>
<style>
.top--negative__8 {
  top: -8px;
  font-size: 10px;
  font-weight: 400;
}

.multiselect__content-wrapper {
  width: fit-content;
  min-width: 100%;
  border: none;
}

.border {
  border-color: #969696 !important;
}

.multiselect__tags {
  border: none;
  padding: 8px 38px 6px 0;
}

.multiselect__select {
  padding-left: 16px;
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 1280px), (max-height: 1080px) {
  ::v-deep .multiselect-component-state {
    .multiselect__content-wrapper {
      max-height: 200px !important;
    }
  }
}

::v-deep .multiselect__content-wrapper {
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
::v-deep .zt-input-focused {
  color: transparent;
}
</style>
